import React, { Component } from "react";

class Navbar extends Component {
    render() {
        return (
            <div className="app-header header--transparent sticker" id="main-menu">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-sm-5 col-5">
                            <div className="logo">
                                <a href={`${process.env.PUBLIC_URL}/`}>
                                    <img className="logo-1" src={require('../assets/images/logo/mapptrix.png')} style={{ height: 90 }} alt="app landing" />
                                    <img className="logo-2" src={require('../assets/images/logo/mapptrix.png')} style={{ height: 90 }} alt="app landing" />
                                    <img className="logo-3" src={require('../assets/images/logo/mapptrix.png')} style={{ height: 90 }} alt="app landing" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-8 d-none d-lg-block">
                            <div className="mainmenu-wrapper">
                                <nav>
                                    <ul className="main-menu">
                                        <li className="active"><a href="#home">INICIO</a></li>
                                        <li><a href="#about">ACERCA DE MAPPTRIX</a></li>
                                        <li><a href="#features">APP MÓVIL DE UBICACIÓN</a></li>
                                        {/* <li><a href="#pricing">FUNCIONES</a></li> */}
                                        <li><a href="#reviews">FUNCIONES</a></li>
                                        <li><a href="#screenshots">OBJETOS DISPONIBLES</a></li>
                                        <li><a href="#support">SOPORTE TÉCNICO</a></li>
                                    </ul>
                                </nav>
                                <a href="#download" className="button-default button-olive">DESCARGAR</a>
                                <a href="https://console.mapptrixapp.com" target="_blank" rel="noopener noreferrer" className="button-default button-olive" style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>INICIAR SESIÓN</a>
                            </div>
                        </div>
                        <div className="col-sm-7 col-7 d-block d-lg-none">
                            <div className="mobile-menu">
                                <nav>
                                    <ul>
                                        <li className="active"><a href="#home">INICIO</a></li>
                                        <li><a href="#about">ACERCA DE MAPPTRIX</a></li>
                                        <li><a href="#features">APP MÓVIL DE UBICACIÓN</a></li>
                                        {/* <li><a href="#pricing">Pricing</a></li> */}
                                        <li><a href="#reviews">FUNCIONES</a></li>
                                        <li><a href="#screenshots">OBJETOS DISPONIBLES</a></li>
                                        <li><a href="#support">SOPORTE TÉCNICO</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Navbar;


